export function formatEUR(
  price?: number | string | null,
  precision?: number,
): string {
  if (price === undefined || price === null || price === '') {
    return '';
  }

  const numericPrice = Number(price);
  if (!Number.isFinite(numericPrice)) {
    return '';
  }

  const isInteger = Number.isInteger(numericPrice);

  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: isInteger ? 0 : precision,
    maximumFractionDigits: isInteger ? 0 : precision,
  }).format(numericPrice);
}

export const numberToLocaleString = (
  num?: number,
  unit?: string,
  precision?: number,
) => {
  return `${num?.toLocaleString('fr-FR', { maximumFractionDigits: precision ?? 2 })} ${unit || ''}`.trim();
};
